/*
 * ******************************************************************
 * Copyright (c) 2020-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { ComponentFactory, ComponentFactoryResolver, ComponentRef, Directive, ViewContainerRef } from "@angular/core";
import { DialogKeyService } from "../dialog-key.service";
import { ClosableDialog } from "../closable-dialog";

// @formatter:off
@Directive({
    standalone: false,
    selector: "[dialogAnchor]"
})
// @formatter:on
export class DialogAnchorDirective {
    constructor(public viewContainer: ViewContainerRef,
                public componentFactoryResolver: ComponentFactoryResolver,
                private _dialogKeyService: DialogKeyService) {
    }

    createDialog(dialogComponent: { new(...args: any[]): ClosableDialog })
        : ComponentRef<ClosableDialog> {
        const dialogComponentFactory: ComponentFactory<ClosableDialog> =
            this.componentFactoryResolver.resolveComponentFactory(dialogComponent);
        const dialogComponentRef: ComponentRef<ClosableDialog> =
            this.viewContainer.createComponent(dialogComponentFactory);

        const dialogRef: ClosableDialog = dialogComponentRef.instance;

        this._dialogKeyService.registerDialog(dialogRef);

        dialogRef.dialogClosed.subscribe(() => {
            this._dialogKeyService.unregisterDialog();
            dialogComponentRef.destroy();
        });

        return dialogComponentRef;
    }
}
